import React from 'react'

export const SunIcon: React.FC = () => (
  <svg viewBox='0 0 34 34' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g clipPath='url(#clip0_2503_371)'>
      <path
        d='M17.0001 24.0833C20.9121 24.0833 24.0834 20.912 24.0834 17C24.0834 13.0879 20.9121 9.91663 17.0001 9.91663C13.0881 9.91663 9.91675 13.0879 9.91675 17C9.91675 20.912 13.0881 24.0833 17.0001 24.0833Z'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M17 1.41663V4.24996'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M17 29.75V32.5833'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M5.97827 5.97839L7.98994 7.99006'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M26.01 26.01L28.0217 28.0217'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M1.41675 17H4.25008'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M29.75 17H32.5833'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M5.97827 28.0217L7.98994 26.01'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M26.01 7.99006L28.0217 5.97839'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </g>
    <defs>
      <clipPath id='clip0_2503_371'>
        <rect width='34' height='34' fill='white' />
      </clipPath>
    </defs>
  </svg>
)
